var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 858",
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FBBE08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LinkedIn",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.799 20.8015H17.9699V16.3016C17.9699 15.124 17.5277 14.3199 16.5544 14.3199C15.8102 14.3199 15.3963 14.8626 15.2037 15.3855C15.1312 15.573 15.1426 15.8344 15.1426 16.0959V20.8015H12.34C12.34 20.8015 12.376 12.8306 12.34 12.1061H15.1426V13.4709C15.3084 12.8741 16.2038 12.0226 17.6328 12.0226C19.4059 12.0226 20.799 13.2731 20.799 15.9666V20.8015ZM9.50593 11.0184H9.48761C8.58462 11.0184 7.99902 10.3538 7.99902 9.51122C7.99902 8.65234 8.60179 8.00146 9.5231 8.00146C10.4435 8.00146 11.0096 8.65074 11.0274 9.50866C11.0274 10.3512 10.4435 11.0184 9.50593 11.0184ZM8.32193 12.1061H10.8168V20.8015H8.32193V12.1061Z",
    fill: "#FBBE08"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.cdcf6e4c42c383492b132d3152d8e6cf.svg";
export { ForwardRef as ReactComponent };